<div class="error-container">
  <div>
    <div class="error-message">
      <div class="error-title"><span class="error-title title">Oops! Algo deu errado</span></div>
      <div>
        <span class="error-description">{{ errorMessageDescription }}</span>
      </div>
    </div>
  </div>
</div>